import { Media } from '@gripp/shared-logic';
import { SingleStateConfig } from './routineConfig';
import { RoutineState } from './routineState';

export interface CounterBaseConfig {
  uom: string;
  decimal?: boolean;
  decimalPlaces?: number;
  placeholder?: string;
  counterType?: CounterType;
  media?: Media;
}

export interface CounterConfig extends SingleStateConfig, CounterBaseConfig {}

export interface CounterResponse {
  count: number;
  userCount?: number;
  oldValue?: number;
  uom?: string;
  counterType?: CounterType;
}
export interface CounterState extends RoutineState, CounterResponse {}

export enum CounterType {
  Simple = 'SIMPLE',
  Cumulative = 'CUMULATIVE',
  Tally = 'TALLY',
}
